import { render, staticRenderFns } from "./TiposActividadGrid.vue?vue&type=template&id=a1ad0bec&"
import script from "./TiposActividadGrid.vue?vue&type=script&lang=ts&"
export * from "./TiposActividadGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a1ad0bec', component.options)
    } else {
      api.reload('a1ad0bec', component.options)
    }
    module.hot.accept("./TiposActividadGrid.vue?vue&type=template&id=a1ad0bec&", function () {
      api.rerender('a1ad0bec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/TiposActividad/TiposActividadGrid.vue"
export default component.exports